import { InnerQueryExpression } from "../InnerQueryExpression";

export class ValueReferenceExpression implements InnerQueryExpression {
    public readonly $discriminator = "ValueReference";
    public readonly fieldName: string;

    public constructor(fieldName: string) {
        this.fieldName = fieldName;
    }
}
